import { Button } from "@mui/material";

const MuiButton = ({ label, ...rest }) => (
  <Button {...rest}>{label}</Button>
);

export default MuiButton;
